import { createSelector } from '@reduxjs/toolkit'
import type { RootState } from 'domains/store'

export const selectTranslations = createSelector(
  ({ i18n }: RootState) => i18n,
  ({ translations }) => translations,
)

export const selectInitialLocale = createSelector(
  ({ i18n }: RootState) => i18n,
  ({ initialLocale }) => initialLocale,
)

export const selectLocale = createSelector(
  ({ i18n }: RootState) => i18n,
  ({ userLocale }) => userLocale,
)

export const selectIsLoading = createSelector(
  ({ i18n }: RootState) => i18n,
  ({ isLoading }) => isLoading,
)
